import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Drawer,
  Select,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import LanguageIcon from "@mui/icons-material/Language";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import "./Newhome.css";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";
import FeedbackModal from "./FeedbackModal";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import TranslateIcon from "@mui/icons-material/Translate";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { useLanguage } from "../../../utils/languageContext";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";

const Newhome = () => {
  const [open, setOpen] = React.useState(false);
  const [openFeedback, setOpenFeedback] = React.useState(false);
  const { currentLanguage, changeLanguage, t } = useLanguage();

  const navigate = useNavigate();

  const NavButton = ({ to, onClick, children }) => {
    const navigate = useNavigate();
    const handleClick = () => {
      if (onClick) {
        onClick();
      } else if (to) {
        navigate(to);
      }
    };
    return (
      <Button className="menu-link" onClick={handleClick}>
        {children}
      </Button>
    );
  };

  const scrollToAbout = () => {
    const section = document.getElementById("about-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  // -----Auto close mobile menu
  const handleMenuClick = (action) => {
    setOpen(false);
    if (action) {
      action();
    }
  };

  return (
    <>
      {/* 🔝 TOP HEADER */}
      <AppBar position="static" className="top-newheader">
        <Toolbar className="top-toolbar">
          <div className="font-controls">
            <img src="/images/IndiaFlag.svg" alt="" />
          </div>

          <div className="top-links">
            {/* <span className="smalla">A</span>
            <span className="medium">A</span>
            <span className="large divider">A</span> */}

            <div
              className="screen-reader divider"
              onClick={() => navigate("/screen-reader")}
            >
              <VolumeUpIcon />
              <span>{t("homepage.nav.screenReader")}</span>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "13px",
              }}
              onClick={() => navigate("/sitemap")}
            >
              <LocationOnIcon />
              <span>{t("homepage.nav.sitemap")}</span>
            </div>
          </div>
        </Toolbar>
      </AppBar>

      {/* 🧭 MAIN NAVBAR */}
      <AppBar position="static" className="main-navbar">
        <Toolbar className="main-toolbar">
          {/* LEFT LOGO */}
          <Box className="logo-section">
            <img
              src="/images/Swastbharatlogo.svg"
              alt="logo"
              className="firstlogoheader"
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            />
            <img
              src="/images/National-health-mission.svg"
              alt="logo"
              className="nhmlogo_header"
            />
          </Box>

          {/* CENTER EMBLEM */}
          <Box className="center-logo">
            <img src="/images/emblem.svg" alt="emblem" />
          </Box>

          {/* DESKTOP MENU */}
          <Box className="menu-section">
            <NavButton to="/">{t("homepage.nav.home")}</NavButton>
            <NavButton onClick={scrollToAbout}>{t("homepage.nav.about")}</NavButton>
            <NavButton onClick={() => navigate("/user-manual")}>{t("homepage.nav.usermanual")}</NavButton>
            <NavButton onClick={() => setOpenFeedback(true)}>
              {t("homepage.nav.feedback")}
            </NavButton>

            {/* ── Language Select ── */}
            <div className="language-box">
              <LanguageIcon style={{ fontSize: 18, color: "#555" }} />
              <Select
                size="small"
                value={currentLanguage}
                onChange={(e) => changeLanguage(e.target.value)}
                variant="standard"
                disableUnderline
                sx={{
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#333",
                  "& .MuiSelect-select": { paddingBottom: 0 },
                }}
              >
                <MenuItem value="English">English</MenuItem>
                <MenuItem value="हिन्दी">हिन्दी</MenuItem>
              </Select>
            </div>

            <Button onClick={() => navigate("/login")} className="feedback-btn">
              {t("homepage.nav.login")}
            </Button>
          </Box>

          {/* MOBILE MENU ICON */}
          <IconButton className="mobile-menu" onClick={() => setOpen(true)}>
            <MenuIcon />
          </IconButton>

          {/* DRAWER */}
          <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
            <Box className="drawer-menu">
              <List>
                <ListItemButton onClick={() => handleMenuClick(() => navigate("/"))}>
                  <ListItemIcon>
                    <HomeOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("homepage.nav.home")} />
                </ListItemButton>
                <Divider />

                <ListItemButton onClick={() => handleMenuClick(scrollToAbout)}>
                  <ListItemIcon>
                    <InfoOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("homepage.nav.about")} />
                </ListItemButton>
                <Divider />

                <ListItemButton
                  onClick={() => handleMenuClick(() => navigate("/user-manual"))}
                >
                  <ListItemIcon>
                    <MenuBookOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("homepage.nav.usermanual")} />
                </ListItemButton>
                <Divider />

                <ListItemButton
                  onClick={() => handleMenuClick(() => setOpenFeedback(true))}
                >
                  <ListItemIcon>
                    <FeedbackOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("homepage.nav.feedback")} />
                </ListItemButton>
                <Divider />

                <ListItemButton
                  onClick={() => handleMenuClick(() => navigate("/login"))}
                >
                  <ListItemIcon>
                    <LoginOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("homepage.nav.login")} />
                </ListItemButton>
                <Divider />

                {/* ── Mobile Language Select ── */}
                <ListItemButton sx={{ gap: 1 }}>
                  <ListItemIcon>
                    <TranslateIcon />
                  </ListItemIcon>
                  <Select
                    size="small"
                    value={currentLanguage}
                    onChange={(e) => {
                      changeLanguage(e.target.value);
                      setOpen(false);
                    }}
                    variant="standard"
                    disableUnderline
                    fullWidth
                    sx={{ fontSize: "14px", color: "#6f6f6f", fontWeight: 500 }}
                  >
                    <MenuItem value="English">English</MenuItem>
                    <MenuItem value="हिन्दी">हिन्दी</MenuItem>
                  </Select>
                </ListItemButton>
              </List>
            </Box>
          </Drawer>
        </Toolbar>
      </AppBar>

      {/* ===Model Feedback ========= */}
      <FeedbackModal
        open={openFeedback}
        handleClose={() => setOpenFeedback(false)}
      />
    </>
  );
};

export default Newhome;
